import { cloneDeep } from 'lodash';
import { isEmpty } from '@/common/utils/Util';

export default {
  setDetail: (state, data) => {
    state.detail = data;
  },
  setFaqList: (state, list) => {
    if (isEmpty(state.faqList)) {
      state.faqList = list;
    } else {
      state.faqList = [...state.faqList, ...list];
    }
  },
  setCondition: (state, condition) => {
    Object.assign(state.condition, condition);
  },
  initPage: state => {
    state.condition.page = 1;
    state.condition.limit = 10;
    state.faqList = [];
  }
};
